module.exports = __webpack_public_path__ + "7411a4b3b5338e43ccbce696c290d316.png";